<template>
  <div>
    <div class="card-header bg-light fw-bold">
      <span class="material-icons align-middle me-1" style="font-size:18px">toggle_on</span>
      Activación de registros detalle
    </div>
    <hr />

    <DataTable
      :data="planilladets"
      :columns="columnas"
      idField="idPlanillaDet"
      :acciones="auditoriaMedica"
      :mostrarBotonNuevo="false"
      :mostrarBotonTodos="true"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonExcel="false"
      accionesWidth="60px"
      mensajeVacio="No se recuperaron registros."
      @refresh="getDataTodos"
    >
      <!-- Fila de total en el footer via slot acciones-extra -->
<!--	  
      <template #acciones-extra>
        <div class="col-auto ms-2 small text-muted fw-bold align-self-center">
          Total visible: <strong>{{ calcularTotal }}</strong>
        </div>
      </template>
-->
      <!-- Botón toggle en la columna de acciones -->
      <template v-if="auditoriaMedica" #acciones-fila="{ row }">
        <button
          type="button"
          :class="row.estado === 1
            ? 'btn btn-sm btn-outline-primary'
            : 'btn btn-sm btn-outline-secondary'"
          @click="actualizarEstado(row)"
          :title="row.estado === 1 ? 'Desactivar' : 'Activar'"
        >
          <span class="material-symbols-outlined" style="font-size:18px">
            {{ row.estado === 1 ? 'toggle_on' : 'toggle_off' }}
          </span>
        </button>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable  from '@/components/DataTable.vue';
import api        from '@/services/api';
import dateFormat from '@/modules/dateFormat.js';
import * as $    from 'jquery';
window['$'] = $;
window['jQuery'] = $;
import swal from 'sweetalert';

export default {
  components: { DataTable },
  props: {
    p_idTramite:     { type: Number,  required: true },
    p_idPrestador:   { type: Number,  required: true },
    p_estadoTramite: { type: String,  required: true },
    p_idPlanilla:    { type: Number,  required: true },
    p_numero:        { type: String,  required: true },
    p_tipo:          { type: String,  required: true },
    p_procesoAM:     { type: Boolean, required: true },
  },
  data() {
    return {
      planilladets:   [],
      datoPlanillaDet:{},
      idPerfil:       0,
      // columnas DataTable
      columnas: [
        {
          field:      'fechaAtencion',
          label:      'Fecha',
          date:       true,
          format:     v => dateFormat.getFormattedDate(v),
        },
        {
          field:      'elementoCodigo',
          label:      'Código TPSNS',
          filterType: 'text',
        },
        {
          field:      'elementoNombre',
          label:      'Elemento TPSNS',
          filterType: 'text',
        },
        {
          field:      'cantidad',
          label:      'Cantidad',
          numeric:    true,
        },
        {
          field:      'valorUni',
          label:      'V. Unitario',
          numeric:    true,
        },
        {
          field:      'valorTotal',
          label:      'V. Total',
          numeric:    true,
          format:     (_, row) => (row.cantidad * row.valorUni).toFixed(2),
        },
      ],
    };
  },
  computed: {
    auditoriaMedica() {
      return (
        [16, 17, 18].includes(Number(this.idPerfil)) &&
        ['RECIBIDO', 'EN PROCESO', 'PLANILLAJE'].includes(this.p_estadoTramite)
      );
    },
    calcularTotal() {
      return this.planilladets
        .reduce((t, p) => t + p.cantidad * p.valorUni, 0)
        .toFixed(2);
    },
  },
  mounted() {
    this.idPerfil = window.sessionStorage.getItem('idPerfil');
    this.getDataTodos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    formatearFecha(fecha) {
      const f = new Date(fecha);
      return isNaN(f.getTime()) ? '' : f.toISOString().split('T')[0];
    },
    ordenarPorFechaYElemento(arr) {
      return arr.sort((a, b) => {
        const fa = new Date(a.fechaAtencion), fb = new Date(b.fechaAtencion);
        if (fa < fb) return 1;
        if (fa > fb) return -1;
        if (a.elementoCodigo < b.elementoCodigo) return -1;
        if (a.elementoCodigo > b.elementoCodigo) return 1;
        return 0;
      });
    },
    getDataTodos() {
      api.get(`/vwplanilladets/idplanilla-estado/${this.p_idPlanilla}/0`)
        .then(response => {
          this.planilladets = this.ordenarPorFechaYElemento(response.data);
        });
    },
    async actualizarEstado(planilladet) {
      try {
        this.datoPlanillaDet.idPlanilla = this.p_idPlanilla;
        await api.post('/planilladets/activar', planilladet);
        this.getDataTodos();
      } catch {
        swal('Error!', 'Intentelo de nuevo!', 'error');
      }
    },
    async deletePlanillaDet(idPlanillaDet) {
      try {
        await api.delete('/planilladets/' + idPlanillaDet);
        this.getDataTodos();
      } catch (error) {
        alert('No se pudo eliminar. ' + error);
      }
    },
    observaciones(idPlanillaDet) {
      if (idPlanillaDet != null) {
        this.$router.push(
          `/planilladet_pladetobs/${this.p_idTramite}/${this.p_estadoTramite}` +
          `/${idPlanillaDet}/${this.p_tipo}/${this.p_procesoAM ? 1 : 0}`
        );
      }
    },
  },
};
</script>

<style scoped>
.table-hover tbody tr { cursor: pointer; }
.table-hover tbody tr:hover { background-color: #f5f5f5; }
</style>